import React, { useState } from "react";
import {
  Container,
  Grid,
  TextField,
  Button,
  Typography,
  Box,
  Paper
} from "@mui/material";

import { Helmet } from "react-helmet";

import { Routes, Route, Navigate } from "react-router-dom";


import { createUseStyles } from "react-jss";

import AuthNavbar from "components/Navigation/Navbars/Auth/AuthNavbar";

import { dashRoutes as routes } from "routes.js";

import styles from "assets/jss/material-dashboard-pro-react/layouts/blogStyle.js";
import Footer from "components/Sales/Footer";
import Banner from "components/Sales/Banner";
import { justifyContent } from "@mui/system";

const useStyles = createUseStyles(styles);

export default function ContactLayout(props) {
  const classes = useStyles();
  const { ...rest } = props;
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

    const getRoutes = (routes) => {
        console.log(routes);

        return routes
        .filter((prop) => prop.layout === "/contact-us")
        .map((prop, key) => {
            if (prop.collapse) {
            return getRoutes(prop.views);
            }

            return (
            <Route path={prop.path} element={<prop.component />} key={key} />
            );
        });
    };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    console.log("Form submitted:", formData);

    // TODO: send to backend / API
  };

  return (
    <>
    <div className={classes.wrapper}>
      <Helmet>
        <title>The Stakeholders.app Journal | Learn Stakeholder Mapping</title>
        <meta
          name="description"
          content="Learn Stakeholder Mapping and Analysis | The Stakeholders.app Journal"
        />
      </Helmet>
      <div className={classes.fullPage}>
        <AuthNavbar {...rest} shrinkOnValue={275} />

        <div className={classes.content}>
          <Banner small />
          <div className={classes.container + " " + classes.padding} style={{display: "flex", justifyContent: "center" }}>
            <Routes>
              {getRoutes(routes)}
              <Route path="/*" element={<Navigate to="/contact-us" replace />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </div>
    </div>
    </>
  );
}